import { GridContainerFullHeight, TextInput, Typography } from '@ts/storybook';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { WrapperEntitySelector } from '@components/Inputs';
import { IForm } from '@ts/ui-models';

interface IDistributionConfigurationFormProps extends IForm {
  values: {
    name: string;
    distributionConfigLists: string[];
  };
}

const DistributionConfigurationForm = (props: IDistributionConfigurationFormProps) => {
  const { mode, values, onCallbackChange, requiredFields } = props;
  const isViewMode = mode === 'view';

  return (
    <GridContainerFullHeight spacing={2}>
      <Typography variant="h6" text="Distribution Configuration" />
      <TextInput
        label="Configuration Name"
        isReadOnly={isViewMode}
        value={values.name}
        onChangeValue={onCallbackChange('name')}
        required={requiredFields?.includes('name')}
      />
      <WrapperEntitySelector
        label={'Add distribution list to configuration'}
        searchComponent={generateSearchEntitySelector('distributionList')}
        value={values.distributionConfigLists}
        onChange={onCallbackChange('distributionConfigLists')}
        isReadOnly={isViewMode}
        required={requiredFields?.includes('distributionList')}
        multiple
      />
    </GridContainerFullHeight>
  );
};

export default DistributionConfigurationForm;
